// @flow
import React from "react";
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import _ from "lodash";
import * as selectors from "../../modules/selectors";

import logoAflFantasyNew from "../../assets/images/logos/svgs/afl-ver-cen-white.svg";
// import presented_toyota from "../../assets/images/presented-toyota.svg";
import { header_height } from "../../assets/css/vars";
import { below } from "../../assets/css/media";
import ProSubscriptionModal from "../../pages/proSubscription/ProSubscriptionModal";
import Hamburger from "../Hamburger";
import Menu from "../Menu";


const LogoWrapper = styled.div`
  width: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 20px 0 16px;
`;

// use div because telstra already using header
const HeaderWrapper = styled.div`
	width: 100%;
	height: 50px;
	background: #023680;
	display: flex;
	flex-direction: row;
	justify-content: center;
	color: #fff;
	position: relative;
	position: sticky;
	left: 0;
	top: 0;
	z-index: 100;
	box-sizing: border-box;
	${props => props.menu_open && `
		&:after {
			content: '';
			display: block;
			width: 50px;
			height: 50px;
			position: absolute;
			top: 0;
			right: 0;
			background-color: #fff;
			z-index: 0;
		}
	`};
`;

const HeaderInner = styled.div`
	width: 100%;
	max-width: 1280px;
	height: ${header_height}px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding-right: 20px;
	box-sizing: border-box;
	${below.tablet`
		justify-content: space-between;
		position: relative;
		padding-right: 16px;
	`};
`;

const LogoContainer = styled(Link)`
	display: block;
	align-self: flex-start;
	height: 48px;
	position: relative;
	z-index: 101;
	img {
		display: block;
		height: 48px;
	}
`;

type Location = {
	hash: string,
	key: string,
	pathname: string,
	search: string
}

type Props = {
	location: Location,
	menu_open: boolean,
	league_id: number,
  has_user: boolean,
};
type State = {
	show_subscription_modal: boolean
}

class Header extends React.PureComponent<Props, State> {
	constructor(props,state) {
		super(props, state);
		this.state = {
			show_subscription_modal: false
		};
		_.bindAll(this, [
			"openSubModal",
			"closeSubModal"
		]);
	}
	openSubModal() {
		this.setState({
			show_subscription_modal: true
		});
	}
	closeSubModal() {
		this.setState({
			show_subscription_modal: false
		});
	}

	get show_on_registration_contact() {
		const { location } = this.props;
		return ["/registration", "/contact-us"].includes(location.pathname) ? true : false;
	}

	get is_no_user_contact_page() {
		const { has_user } = this.props;
		return this.show_on_registration_contact && !has_user;
	}

	render() {
		const { league_id } = this.props;
		const league_object = {
			id: league_id,
			subscription: "",
		};
		return (
			<HeaderWrapper menu_open={this.props.menu_open}>
				{this.state.show_subscription_modal && 	
					<ProSubscriptionModal 
						closeClick={this.closeSubModal} 
						league={league_object}
						is_pro_sub={false}
					/>
				}
				<HeaderInner>
			
					<LogoWrapper>
						<LogoContainer to="/" title="AFL Fantasy Home">
          	   					 <img src={logoAflFantasyNew} alt="AFL Fantasy Logo" />
						</LogoContainer>
						
						{/* <img 
							src={presented_toyota} 
							alt="Presented by Toyota" 
							className="toyota-sponsor"/> */}
							
					</LogoWrapper>
						
					
					
					<Menu menu_open={this.props.menu_open} 
						is_contact_page={this.is_no_user_contact_page}
						openSubModal={this.openSubModal} closeSubModal={this.closeSubModal}/>
					<Hamburger
						menu_open={this.props.menu_open}
						is_contact_page={this.show_on_registration_contact}
					/>
				</HeaderInner>
			</HeaderWrapper>
		);
	}
}

const mapStateToProps = state => ({
	menu_open: state.uiMenu.open,
	league_id: state.leagues.show.league_id,
	has_user: selectors.hasUser(state),
});

export default withRouter(connect(mapStateToProps)(Header));